import dayjs from 'dayjs';
import React from 'react';
import Typography from '@material-ui/core/Typography';
import Author from 'components/Author';
import PaddedDivider from 'components/PaddedDivider';
import {
  MetaTypography,
  MetaWrapper,
  BlogCategories,
  TagList
} from 'views/Blog/elements/BlogMeta';

const PostFooter = ({
  blog_category,
  categories_tags,
  author,
  date,
  date_updated,
  $
}) => (
  <>
    <MetaWrapper spacing={5} justify="space-between">
      <div {...$?.blog_category}>
        <MetaTypography inline>Filed In:&nbsp; </MetaTypography>
        <BlogCategories categories={blog_category} />
      </div>

      {date && (
        <MetaTypography>
          {date_updated ? 'Updated: ' : 'Posted: '}
          <span>
            {dayjs(date_updated || date, 'YYYY-MM-DD').format('MMMM DD, YYYY')}
          </span>
        </MetaTypography>
      )}
    </MetaWrapper>
    <PaddedDivider />
    <TagList categoriesTags={categories_tags} {...$?.categories_tags} />
    {author.length > 0 && (
      <div {...$?.author}>
        <Typography variant="overline" gutterBottom>
          About the Author{author.length > 1 && 's'}
        </Typography>
        {author.map(author => (
          <Author author={author} key={author.uid} />
        ))}
      </div>
    )}
  </>
);

export default PostFooter;
